import Masonry from 'masonry-layout'

export default ({ app }) => {
  app.config.globalProperties.$Masonry = Masonry
}
